import { clsx } from 'clsx';
import JxtHomeBookingSelect from '../JxtHomeBookingSelect';
import { HOME_BOOKING_FIELD as FIELD } from '../JxtHomeBookingSelect/style';
import { IJxtHomeBookingOptions, JxtHomeBookingOptionKindEnum } from './types';

/**
 * The space's options (catering, equipment…), chosen once the space is: each one on or off, with
 * its value when it takes one. A mandatory one is on and says so; left without its value, it is red.
 */
const JxtHomeBookingOptions = ({
  label,
  mandatoryLabel,
  choosePlaceholder,
  options,
  onToggle,
  onValueChange,
}: IJxtHomeBookingOptions) => (
  <fieldset className="flex flex-col gap-2">
    <legend className="pb-2 text-body-xs font-semibold tracking-wide text-neutral-90 uppercase">{label}</legend>
    <ul className="divide-y divide-neutral-20 rounded-xl border border-neutral-20">
      {options.map((option) => (
        <li key={option.id} className="flex flex-col gap-2 px-4 py-3">
          <label className="flex items-center gap-3">
            <input
              type="checkbox"
              checked={option.activated}
              disabled={option.mandatory}
              onChange={(event) => onToggle(option.id, event.target.checked)}
              className="form-checkbox size-4 rounded-sm border-neutral-40 text-primary-100 focus:ring-primary-100 disabled:opacity-60"
            />
            <span className="min-w-0 flex-1 text-body-s font-medium text-neutral-140">{option.name}</span>
            {option.mandatory && <span className="text-body-xs text-neutral-90">{mandatoryLabel}</span>}
          </label>
          {option.activated && option.kind !== JxtHomeBookingOptionKindEnum.Checkbox && (
            <div className="pl-7">
              {option.kind === JxtHomeBookingOptionKindEnum.List ? (
                <JxtHomeBookingSelect
                  label={option.name}
                  value={option.value}
                  options={option.values.map((value) => ({ value, label: value }))}
                  onChange={(value) => onValueChange(option.id, value)}
                  placeholder={choosePlaceholder}
                  isInvalid={option.isInvalid}
                />
              ) : option.kind === JxtHomeBookingOptionKindEnum.Textarea ? (
                <textarea
                  aria-label={option.name}
                  value={option.value}
                  rows={2}
                  onChange={(event) => onValueChange(option.id, event.target.value)}
                  className={clsx(FIELD, 'form-textarea', option.isInvalid && 'border-red-100')}
                />
              ) : (
                <input
                  type="text"
                  aria-label={option.name}
                  value={option.value}
                  onChange={(event) => onValueChange(option.id, event.target.value)}
                  className={clsx(FIELD, option.isInvalid && 'border-red-100')}
                />
              )}
            </div>
          )}
        </li>
      ))}
    </ul>
  </fieldset>
);

export default JxtHomeBookingOptions;
